<!-- View - Mobilecart - show cart as full page only in mobile, in desktop show as default(drawer) -->
<template>
  <main>
    <PlatformRenderer>
      <!-- onMobile show cart drawer as a full page '/mcart' -->
      <template v-slot:onMobile>
        <WCCartDrawer
          :line-items="getCartItems"
          :outofstock-line-items="getOutOfStockLineItemsOfType(1)"
          class="w-100"
        />
      </template>
      <template v-slot:onDesktop></template>
    </PlatformRenderer>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import WCCartDrawer from '@/modules/cart/components/WCCartDrawer/WCCartDrawer.vue';
import PlatformRenderer from '../../modules/platform/components/PlatformRenderer';

export default {
  components: { WCCartDrawer, PlatformRenderer },
  computed: {
    ...mapGetters({
      getOutOfStockLineItemsOfType: 'cart/getOutOfStockLineItemsOfType',
      cartItems: 'cart/getLineItems',
    }),
    getCartItems() {
      return this.cartItems.filter(item => item.type === 1 || item.type === 60);
    },
  },
};
</script>
